<template>
  <!-- Wearable App Start -->
  <div class="product-wearable-app">
    <!-- Wearable App Tittle -->
    <b-row class="app">
      <b-col lg="" class="app__content">
        <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{ $t('wearable.app.title') }}</span>
        </div>
        <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
          <span v-html="$t('wearable.app.sub-title')"></span>
          <span class="sub-title__exp" v-html="$t('wearable.app.sub-title-exp')"></span>
        </div>
      </b-col>
    </b-row>

    <!-- App Golf Start -->
    <div class="wearable-app">
      <div class="wearable__real-image">
        <!-- not IE -->
        <div v-if="!isIE" v-parallax="0.4" >
          <img src="@/assets/img/products/wearable/img_app_band_golf.png">
        </div>
        <!-- IE (IE 브라우저에서는 parallax 적용 불가) -->
        <div v-else class="wearable__real-image--ie">
          <img src="@/assets/img/products/wearable/img_app_band_golf.png">
        </div>
      </div>
      <b-row class="wearable-app__row">
        <b-col lg="" class="wearable-app__content">
          <div class="wearable-app__title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span>{{ $t('wearable.app.golf.title') }}</span>
          </div>
          <div class="wearable-app__sub-title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.golf.content')"></span>
          </div>
          <div class="wearable-app__hashtag"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.golf.hashtag')"></span>
          </div>
        </b-col>

        <b-row class="wearable-app__row_image">
          <b-col lg="auto" class="wearable-app__app-img-1"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_golf_app1_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.golf.txt-1')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.golf.txt-1')"></span>
            </template>
          </b-col>

          <b-col lg="auto" class="wearable-app__app-img-2"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_golf_app2_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.golf.txt-2')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.golf.txt-2')"></span>
            </template>
          </b-col>
        </b-row>
      </b-row>
    </div>
    <!-- App Golf End -->

    <!-- App Football Start -->
    <div class="wearable-app">
      <div class="wearable__real-image">
        <!-- not IE -->
        <div v-if="!isIE" v-parallax="0.3" >
          <img src="@/assets/img/products/wearable/img_app_band_football.png" alt="for football">
        </div>
        <!-- IE (IE 브라우저에서는 parallax 적용 불가) -->
        <div v-else class="wearable__real-image--ie">
          <img src="@/assets/img/products/wearable/img_app_band_football.png" alt="for football">
        </div>
      </div>
      <b-row class="wearable-app__row">
        <b-col lg="" class="wearable-app__content">
          <div class="wearable-app__title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span>{{ $t('wearable.app.football.title') }}</span>
          </div>
          <div class="wearable-app__sub-title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.football.content')"></span>
          </div>
          <div class="wearable-app__hashtag"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.football.hashtag')"></span>
          </div>
        </b-col>

        <b-row class="wearable-app__row_image">
          <b-col lg="auto" class="wearable-app__app-img-1"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_football_app1_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.football.txt-1')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.football.txt-1')"></span>
            </template>
          </b-col>

          <b-col lg="auto" class="wearable-app__app-img-2"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_football_app2_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.football.txt-2')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.football.txt-2')"></span>
            </template>
          </b-col>
        </b-row>
      </b-row>
    </div>
    <!-- App Football End -->

    <!-- App Swim Start -->
    <div class="wearable-app">
      <div class="wearable__real-image">
        <!-- not IE -->
        <div v-if="!isIE" v-parallax="0.3" >
          <img src="@/assets/img/products/wearable/img_app_band_swim.png" alt="for swim">
        </div>
        <!-- IE (IE 브라우저에서는 parallax 적용 불가) -->
        <div v-else class="wearable__real-image--ie">
          <img src="@/assets/img/products/wearable/img_app_band_swim.png" alt="for swim">
        </div>
      </div>
      <b-row class="wearable-app__row">
        <b-col lg="" class="wearable-app__content">
          <div class="wearable-app__title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span>{{ $t('wearable.app.swim.title') }}</span>
          </div>
          <div class="wearable-app__sub-title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.swim.content')"></span>
          </div>
          <div class="wearable-app__hashtag"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.swim.hashtag')"></span>
          </div>
        </b-col>

        <b-row class="wearable-app__row_image">
          <b-col lg="auto" class="wearable-app__app-img-1"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_swim_app1_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.swim.txt-1')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.swim.txt-1')"></span>
            </template>
          </b-col>

          <b-col lg="auto" class="wearable-app__app-img-2"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_swim_app2_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.swim.txt-2')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.swim.txt-2')"></span>
            </template>
          </b-col>
        </b-row>
      </b-row>
    </div>
    <!-- App Swim End -->

    <!-- App Fitness Start -->
    <div class="wearable-app">
      <div class="wearable__real-image">
        <!-- not IE -->
        <div v-if="!isIE" v-parallax="0.3" >
          <img src="@/assets/img/products/wearable/img_app_band_fitness.png" alt="for fitness">
        </div>
        <!-- IE (IE 브라우저에서는 parallax 적용 불가) -->
        <div v-else class="wearable__real-image--ie">
          <img src="@/assets/img/products/wearable/img_app_band_fitness.png" alt="for fitness">
        </div>
      </div>
      <b-row class="wearable-app__row">
        <b-col lg="" class="wearable-app__content">
          <div class="wearable-app__title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span>{{ $t('wearable.app.fitness.title') }}</span>
          </div>
          <div class="wearable-app__sub-title"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.fitness.content')"></span>
          </div>
          <div class="wearable-app__hashtag"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <span v-html="$t('wearable.app.fitness.hashtag')"></span>
          </div>
        </b-col>

        <b-row class="wearable-app__row_image">
          <b-col lg="auto" class="wearable-app__app-img-1"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_fitness_app1_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.fitness.txt-1')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.fitness.txt-1')"></span>
            </template>
          </b-col>

          <b-col lg="auto" class="wearable-app__app-img-2"
              data-aos="fade-up" :data-aos-duration="duration" data-aos-delay="30">
            <img src="@/assets/img/products/wearable/img_fitness_app2_en.png" alt="app"/>
            <template v-if="$i18n.locale() === 'ko'">
              <span class="wearable-app__text_ko" v-html="$t('wearable.app.fitness.txt-2')"></span>
            </template>
            <template v-else>
              <span class="wearable-app__text_en" v-html="$t('wearable.app.fitness.txt-2')"></span>
            </template>
          </b-col>
        </b-row>
      </b-row>
    </div>
    <!-- App Fitness End -->

  </div>
  <!-- Wearable App End -->
</template>

<script>
import Vue from 'vue';
import VueParallaxJs from 'vue-parallax-js';
import { bgVideoMixin } from '@/components/mixins/bgVideo';
import { checkPCMixin } from '@/components/mixins/checkPC';
import { FadeUpMixin } from '@/components/mixins/FadeUp';
import { setLanguageMixin } from '@/components/mixins/setLanguage';

Vue.use(VueParallaxJs);

export default {
  name: 'WearableApp',
  data() {
    return {
      isIE: false,
    };
  },
  mixins: [setLanguageMixin, bgVideoMixin, checkPCMixin, FadeUpMixin],
  created() {
    // IE 브라우저 체크
    const agent = navigator.userAgent.toLowerCase();
    if ((navigator.appName === 'Netscape'
        && navigator.userAgent.search('Trident') !== -1)
      || (agent.indexOf('msie') !== -1)) { // IE 일 경우
      this.isIE = true;
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/constant';
@import '../../assets/scss/mixins';

.product-wearable-app {
  @include flexbox;
  @include flex-direction(column);
  align-items: center;
  padding: 0 40px;
  & > div {
    width: 100%;
    max-width: 1518px;
  }

  .content {
    &__title {
      color: #707070;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 2.7px;
    }
    &__sub-title {
      margin-bottom: 12%;
    }
  }
}

@media (min-width: 1350px) {
  .app {
    &__content {
      max-width: 950px;
      padding: 0;
      margin-bottom: 7%;
    }
  }
}

.wearable-app__text_ko {
  position: absolute;
  left: -55px;
  top: 22%;
  width: 130px;

  writing-mode: tb-lr;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(270deg);

  font-weight: normal;
  text-align: right;
  font-size: 16px;
  color: #c5c5c5;
}

.wearable-app__text_en {
  position: absolute;
  left: 0;
  top: 22%;

  writing-mode: vertical-lr;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);

  font-weight: normal;
  text-align: right;
  font-size: 16px;
  color: #c5c5c5;
}

.wearable-app {
  color: white;
  //color: black;
  align-items: start;
  text-align: left;
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-height: 1.25;
  margin-bottom: 10%;

  &__row{
    width: inherit;
    position: relative;
    flex-wrap: wrap;
    flex-direction:column;
  }

  &__row_image{
    margin-top: 100px;
    width: inherit;
    flex-wrap: wrap;
    flex-direction:column;
    justify-content: flex-end;
    padding-left: 10%;
    padding-right: 10%;
  }

  &__real-image{
    position: relative;
  }

  &__app-img-1 {
    position: relative;
    width: 80%;
    margin: auto;
    margin-top: 15%;
    margin-bottom: 20%;
      & > img {
        width: 100%;
      }
    }

    &__app-img-2 {
      position: relative;
      width: 80%;
      margin: auto;
      margin-top: 25%;
      margin-bottom: 20%;
      & > img {
        width: 100%;
      }
    }

  &__title {
    margin-top: 4.9%;
    font-size: 18px;
    font-weight: bold;
  }

  &__sub-title {
    margin-top: 0.7%;
    font-size: 12px;
  }

  &__hashtag {
    margin-top: 1.2%;
    font-size: 10px;
  }

}

  /* ------------------
  :: Sensor Real Image CSS
  ------------------ */
  .wearable__real-image {
    width: inherit;
    position: absolute;
    height: 120px;
    left: 0;
    overflow: hidden;
    background: $color-bg-gray;

    & > div > img {
      width: 100%;
      min-width: 600px;
      top: 500px;
      transform: translateY(30%);
    }

    &--ie {
      transform: translateY(-20%);
    }
  }
  @media (min-width: 576px) {
    .wearable-app {
      &__title {
        margin-top: 4.9%;
        font-size: 46px;
        font-weight: bold;
      }

      &__sub-title {
        margin-top: 0.7%;
        font-size: 24px;
      }

      &__hashtag {
        margin-top: 1.2%;
        font-size: 24px;
      }
    }

    .wearable__real-image {
      height: 280px;
      & > div > img {
        min-width: 1070px;
      }
    }
  }

  @media (min-width: 991px) {
    .wearable__real-image {
      height: 340px;
    }

    .wearable-app__row_image{
      margin-top: 150px;
      flex-wrap: nowrap;
      flex-direction:row;
    }

    .wearable-app__app-img-1{
      width: 40%;
    }
    .wearable-app__app-img-2{
      width: 40%;
    }
  }

  @media (min-width: 1840px) {
    .wearable-app {
      height: 800px;

      &__title {
        margin-top: 4.9%;
        font-size: 46px;
        font-weight: bold;
      }

      &__sub-title {
        margin-top: 0.7%;
        font-size: 24px;
      }

      &__hashtag {
        margin-top: 1.2%;
        font-size: 24px;
      }
    }
    .wearable-app__content {
      position: relative;
    }

    .wearable__real-image {
      height: 340px;
      & > div > img {
        min-width: 1670px;
        transform: translateY(-25%);
      }
    }

    .wearable-app__row_image{
      margin-top: 0px;
    }

    .wearable-app__app-img-1{
      position: absolute;
      margin-top: -400px;
      left: 56%;
      width: 420px;
    }
    .wearable-app__app-img-2{
      position: absolute;
      margin-top: -170px;
      left: 82%;
      width: 420px;
    }
  }
</style>
